import React from 'react';
import { useAssessmentData } from './AssessmentDataContext';
import { SectionHeader, ScrollTable, DeltaBadge, icColor, IC_PERIODS } from './shared';

// Extracted verbatim from Assessment.js's IcTable component + its
// `activeTab === 'ic'` render block (Tech Debt 2026-09, "Assessment and
// Backtest are god files" -- remaining-7-tabs context lift). Reads shared
// state from useAssessmentData() instead of via props.

function IcTable({ bandIcs, prevByBand = {} }) {
  if (!bandIcs || bandIcs.length === 0) {
    return <p className="text-gray-500 text-sm">No IC band data available.</p>;
  }
  return (
    <div>
      <p className="text-[12px] text-gray-500 mb-3 leading-relaxed">
        IC = Pearson correlation of score vs return within each non-overlapping score band.
        Positive = higher score within band predicts better outcome. Computed per assessment run, sample-weighted.
      </p>
      <ScrollTable minWidth={480}>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/[0.08]">
              <th className="text-left py-2 px-3 text-[10px] font-medium uppercase tracking-[0.14em] text-gray-600 w-20">Band</th>
              <th className="text-right py-2 px-2 text-[10px] font-medium uppercase tracking-[0.14em] text-gray-600 w-12">N</th>
              {IC_PERIODS.map(p => (
                <th key={p} className="text-right py-2 px-2 text-[10px] font-medium uppercase tracking-[0.14em] text-gray-600 min-w-[58px]">{p}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {bandIcs.map((row) => {
              const prev = prevByBand[row.band];
              return (
                <tr
                  key={row.band}
                  className="border-b border-white/[0.04] hover:bg-white/[0.02] transition-colors"
                >
                  <td className="py-2 px-3 font-mono text-[12px] text-gray-300 font-medium tabular-nums">{row.band}</td>
                  <td className="py-2 px-2 text-right text-gray-500 font-mono tabular-nums text-[11px] whitespace-nowrap">
                    {row.sample_count}
                    <DeltaBadge curr={row.sample_count} prev={prev?.sample_count} decimals={0} suffix="" />
                  </td>
                  {IC_PERIODS.map(p => {
                    const v = row.ic?.[p];
                    return (
                      <td key={p} className={`py-2 px-2 text-right font-mono tabular-nums text-[12px] whitespace-nowrap ${icColor(v)}`}>
                        {v != null ? (v >= 0 ? `+${v.toFixed(3)}` : v.toFixed(3)) : '—'}
                        <DeltaBadge curr={v} prev={prev?.ic?.[p]} decimals={3} suffix="" />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </ScrollTable>
    </div>
  );
}

export default function IcTab() {
  const { data, activeBandIcByBand } = useAssessmentData();
  const { band_ics } = data;
  return (
  <>
    <SectionHeader>Intra-band information coefficient</SectionHeader>
    <IcTable bandIcs={band_ics} prevByBand={activeBandIcByBand} />
  </>
  );
}
